import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import authComponent from '../auth/auth.vue'
import layout from '../components/Layout.vue'
import exercises from '../components/ExercisesView'
import authentication from '../auth/authService'
import exerciseDetail from '../components/exercises/exercise.detail'
import logout from '../components/SignedOutView'
import createTeam from '../components/teams/team.create'
import teamLayout from '../components/teams/teams.layout'
import teamManagement from '../components/teams/team.management'
import teamSessions from '../components/teams/team.sessions'
import teamDetail from '../components/teams/teams.detail'
import teamEventsPub from '../components/teams/team.events.pub'
import teamCreated from '../components/teams/team.create.completed'
import trainingLayout from '../components/trainingSessions/training.layout'
import trainingCopy from '../components/trainingSessions/training.copy'
import trainingCreate from '../components/trainingSessions/training.create'
import trainingModify from '../components/trainingSessions/training.modify'
import trainingSummary from '../components/trainingSessions/training.summary'
import trainingCreated from '../components/trainingSessions/training.create.completed'
import trainingFeedback from '../components/trainingSessions/training.feedback'
import exLayout from '../components/exLayout'
import masteriesList from '../components/ballmasteries/masteries.list'
import masteriesdetail from '../components/ballmasteries/masteries.detail'
import presence from '../components/trainingSessions/Presence'
import playerProfile from '../components/players/player.profile'
import teamAddNewPlayer from '../components/teams/team.player.add.new'
import teamInvite from '../components/teams/team.invite'
import teamAddUsers from '../components/teams/teams.add.to.users'
import teamMatchCreate from '../components/teams/team.match.create'
import mailLayout from '../components/mails/mails.layout'
import mailWrite from '../components/mails/mails.write'
import adminLayout from '../components/administration/admin.layout'
import adminStatus from '../components/administration/admin.status'
import me from '../components/users/me'
import today from '../components/users/today'
import teamEventParticipatePub from '../components/teams/team.event.participate.pub'

Vue.use(Router)

const routes = new Router({
  mode: 'history',
  routes: [{
    component: layout,
    path: '/',
    children: [

      {
        path: '/',
        name: 'home',
        component: Home,
        meta: { display: 'home' }
      },
      {
        path: 'admin',
        name: 'admin',
        component: adminLayout,
        children: [
          {
            path: 'status',
            name: 'admin.status',
            component: adminStatus
          }
        ]
      },
      {
        path: 'me',
        name: 'me',
        component: me
      },
      {
        path: 'today',
        name: 'today',
        component: today
      },
      {
        path: 'mail',
        name: 'mail',
        component: mailLayout,
        children: [
          {
            path: 'new/:team?',
            name: 'mail.write',
            component: mailWrite
          }
        ]
      },
      {
        path: 'player/:id',
        name: 'player.profile',
        component: playerProfile,
        meta: { display: 'Spieler' }
      },
      {
        path: 'masteries',
        name: 'masteries',
        component: exLayout,
        redirect: { name: 'masteries.list' },
        children: [
          {
            path: 'list',
            name: 'masteries.list',
            component: masteriesList,
            meta: { display: 'Masteries' }
          },
          {
            path: 'ex/:id',
            name: 'masteries.detail',
            component: masteriesdetail,
            meta: { display: 'Mastery' }
          }
        ]
      },
      {
        path: 'training',
        name: 'training',
        component: trainingLayout,
        redirect: { name: 'training.sessions.create' },
        children:
          [
            {
              path: 'summary/:id',
              name: 'training.summary',
              component: trainingSummary
            },
            {
              path: 'copy/:id',
              name: 'training.copy',
              component: trainingCopy
            },
            {
              path: 'create',
              name: 'training.sessions.create',
              component: trainingCreate,
              meta: { display: 'Neues Training' }
            },
            {
              path: 'edit/:id',
              name: 'training.sessions.modify',
              component: trainingModify,
              meta: { display: 'Training bearbeiten' }
            },
            {
              path: 'presence/:id',
              name: 'training.sessions.presence',
              component: presence,
              meta: { display: 'Anwesenheit' }
            },
            {
              path: 'ready/:id',
              name: 'training.sessions.ready',
              component: trainingCreated
            },
            {
              path: 'feedback/:id',
              name: 'training.feedback',
              component: trainingFeedback

            }
          ]
      },

      {
        path: 'pub/event/participate/:id',
        name: 'team.event.participate',
        component: teamEventParticipatePub
      },
      {
        path: 'pub/team/:id',
        name: 'team.events.pub',
        component: teamEventsPub

      },
      {
        path: 'teams',
        name: 'teams',
        component: teamLayout,
        meta: { display: 'Teams' },
        redirect: { name: 'teams.manage' },
        children: [
          {
            path: ':id/players/add',
            name: 'teams.player.add',
            component: teamAddNewPlayer

          },
          {
            path: 'me',
            name: 'teams.manage',
            component: teamManagement,
            meta: { display: 'Verwalten' }
          },
          {
            path: 'add/:id/:users*',
            name: 'teamsAddToTUsers',
            component: teamAddUsers,
            meta: { display: 'Mitglieder hinzufügen' }
          },
          {
            path: 'sessions/:id',
            name: 'teams.sessions',
            component: teamSessions,
            meta: { display: 'Trainings Einheiten' }
          },
          {
            path: 'create',
            name: 'teams.create',
            component: createTeam,
            meta: { display: 'Team erstellen' }
          },
          {
            path: 'detail/:id',
            name: 'teams.detail',
            component: teamDetail,
            meta: { display: 'Team' }
          },

          {
            path: 'invitation/:id/:code',
            name: 'teams.invite',
            component: teamInvite,
            meta: { display: 'Invitation' }
          },
          {
            path: 'ready',
            name: 'team.created',
            component: teamCreated
          },
          {
            path: 'matches/create',
            name: 'team.matches.create',
            component: teamMatchCreate
          }

        ]
      },
      {
        path: 'logout',
        name: 'logout',
        component: logout
      },
      {
        path: 'exercises',
        name: 'exercises',
        component: exercises,
        meta: { display: 'Übungen' }
      },
      {
        path: 'ex',
        name: 'ex',
        component: exLayout,
        children: [{
          path: ':key',
          name: 'excercisesDetails',
          meta: { display: 'Details' },
          component: exerciseDetail
        }]
      },
      {
        path: 'auth',
        component: authComponent
      }
    ]
  }]
})

routes.beforeEach(async (to, from, next) => {
  if (to.name === 'auth' || to.path === '/auth' || to.path === '/logout' || to.name === 'team.events.pub' || to.name === 'team.event.participate') {
    return next()
  } else {
    const user = await authentication.getUser()
    const timestamp = Math.round((new Date()).getTime() / 1000)

    if (user && user.access_token && user.expires_at > timestamp) {
      return next()
    } else {
      localStorage.setItem('loginRedirect', to.fullPath)
      authentication.login()
    }
  }
})

export default routes
